var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'activeCall'
        });
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.location')) + "\n      ")]), _c('v-spacer')], 1), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": "",
      "mb-3": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('GmapMap', {
    ref: "mapRef",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "center": {
        lat: this.latest.latitude,
        lng: this.latest.longitude
      },
      "zoom": 7
    }
  }, _vm._l(_vm.markers, function (m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      }
    });
  }), 1), this.directionsloading ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20vh",
      "left": "20vw",
      "z-index": "9999"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "128",
      "width": "16",
      "color": "white"
    }
  })], 1) : _vm._e()], 1), this.latestETA ? _c('v-flex', {
    staticClass: "text-xs-center mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [this.locationError ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n            There was an error getting your location " + _vm._s(this.locationError) + "\n          ")]) : _vm._e(), _c('v-card-title', [_vm._v("Address: " + _vm._s(this.getActiveCall.company) + ",\n            " + _vm._s(this.getActiveCall.address_line_1) + "\n            " + _vm._s(this.getActiveCall.postcode) + "\n          ")]), _c('v-card-title', [_vm._v("Time to Destination: " + _vm._s(this.timeToDestination))]), _c('v-card-title', [_vm._v("Distance: " + _vm._s(this.distanceToDestination))])], 1)], 1) : _c('v-flex', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "32"
    }
  }), _vm._v("\n        Calculating...\n      ")], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }